import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Device, until } from '@helpers/media';
import DotPaginationStyles from '@stories/Components/Misc/DotPagination/DotPagination.styles';
import styled from 'styled-components';
const Container = styled.div `
  --controlsColour: ${brand.green};

  display: flex;
  gap: 24px;
  padding: 4px 0;
  place-content: center;
  place-items: center;

  ${DotPaginationStyles.Container} {
    flex: 1;
  }

  @media ${until(Device.Tablet)} {
    &[data-hide-pagination-mobile='true'] {
      ${DotPaginationStyles.Container} {
        display: none;
      }
    }
  }

  &[data-vertical='true'] {
    ${DotPaginationStyles.Container} {
      display: none;
    }
  }
`;
const ButtonWrapper = styled.div `
  display: flex;

  [data-vertical='true'] & {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
`;
const Button = styled.button `
  ${ButtonReset}
  display: flex;
  border-radius: 50%;
  height: 48px;
  place-content: center;
  place-items: center;
  width: 48px;
  color: var(--controlsColour);
  ${transition('transform')};

  svg {
    display: block;
    height: 28px;
    width: 28px;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: -3px;
    outline-width: 3px;
  }

  &.focus-ring,
  &:hover {
    transform: scale(1.2);
  }

  &:disabled {
    opacity: 0.5;
    transform: none;
  }
`;
const ControlsStyles = {
    ButtonWrapper,
    Button,
    Container,
};
export default ControlsStyles;
